/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkStatus } from '../../enums/ThunkStatus';
import {
  selectActiveCategory,
  selectCategories,
  selectCategoryStatuses,
  setActiveCategoryLabel,
} from './dashboard.slice';

export function useDashboard() {
  const dispatch = useDispatch();
  const [loadingError, setLoadingError] = useState(false);
  const categories = useSelector(selectCategories);
  const activeCategory = useSelector(selectActiveCategory);
  const categoryDataStatuses = useSelector(selectCategoryStatuses);
  const onTabChange = async (event, category) => dispatch(setActiveCategoryLabel(category));

  useEffect(() => {
    const allEqual = categoryDataStatuses?.every(v => v === categoryDataStatuses?.[0]);
    setLoadingError(allEqual && categoryDataStatuses?.[0] === ThunkStatus.FAILED);
  }, [categoryDataStatuses]);

  return {
    categories,
    activeCategory: activeCategory?.label,
    loadingError,
    onTabChange,
  };
}
